export default "__VITE_ASSET__5b29f8fa__"